import React, { useMemo } from 'react'
import {
  AttributeGroup,
  cleanGroupAttributes
} from './AttributeGroup'
import { ProductDetail } from './ProductDetail'
import ProductImages from './ProductImages'

const disallowedVariesAttributes = ['sku']
const disallowedVariesTypes = ['kvplist']

const AttributesAndVariations = ({
  groupedAttributes,
  formDisabled,
  catalog,
  productId,
  product,
  retailerProduct,
  availableCategories,
  validationErrors,
  updateProductState,
  variesBy,
  availableAttributes,
  partnerId,
  isRetailer,
  refreshing
}) => {
  const filteredVariesByOptions = useMemo(() =>
    variesBy.options
      .filter(
        (option, index, self) =>
          self.findIndex(t => t.label === option.label) === index
      )
      .filter(
        option => !disallowedVariesAttributes.includes(option.value)
      )
      .filter(field => !disallowedVariesTypes.includes(field.type)),
    [variesBy.options]
  );

  const filteredVariesByFields = useMemo(() =>
    variesBy.fields
      .filter(
        (field, index, self) =>
          self.findIndex(t => t.label === field.label) === index
      )
      .filter(field => !disallowedVariesAttributes.includes(field.value))
      .filter(
        field =>
          !variesBy.options
            .map(option => option.value)
            .includes(field.value)
      )
      .filter(field => !disallowedVariesTypes.includes(field.type)),
    [variesBy.fields, variesBy.options]
  );

  return (
    <>
      {Object.keys(groupedAttributes).map((group, index) => {
        const cleanedGroupAttributes = cleanGroupAttributes(groupedAttributes[group], product);
        if (cleanedGroupAttributes.length === 0) return null

        return (
          <React.Fragment key={index}>
            <AttributeGroup
              disabled={formDisabled}
              currentCatalog={catalog}
              group={cleanedGroupAttributes}
              name={group}
              productId={productId}
              product={product}
              retailerProduct={retailerProduct}
              availableCategories={availableCategories}
              errors={validationErrors}
              onChange={updateProductState}
              refreshing={refreshing}
              filteredVariesByOptions={filteredVariesByOptions}
              filteredVariesByFields={filteredVariesByFields}
              availableAttributes={availableAttributes}
              partnerId={partnerId}
              isRetailer={isRetailer}
              catalog={catalog}
            />

            {group === 'Basics' &&
              groupedAttributes['Media'] &&
              groupedAttributes['Media'].some(
                attribute => attribute.Type === 'image'
              ) && (
                <ProductDetail
                  key={'media'}
                  listkey={'media'}
                  title={'Media'}
                  id={'Media'}
                  content={
                    <ProductImages
                      groupedAttributes={groupedAttributes}
                      group={'Media'}
                      catalog={catalog}
                      partnerId={partnerId}
                      isRetailer={isRetailer}
                      product={product}
                      updateProductState={updateProductState}
                      disabled={formDisabled}
                    />
                  }
                />
              )}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default React.memo(AttributesAndVariations);
